import { Form, Input } from 'antd';
import React, { FC } from 'react';
import style from './index.module.scss';

type TProps = {
  name: string;
  placeholder: string;
  onSearch: (data: string) => void;
};

const NumberFormItem: FC<TProps> = ({ onSearch, name, placeholder }) => {
  return (
    <Form.Item name={name} className={style.searchInput} normalize={value => value.replace(/[^0-9]/g, '')}>
      <Input.Search placeholder={placeholder} allowClear onSearch={onSearch} maxLength={8} />
    </Form.Item>
  );
};

export default NumberFormItem;
